import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import Partners from "./Partners.svelte";

export default {
    component: Partners,
    name: "Partners",
    description: "Showcase partner organisations with logos",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/affiliate.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F169462eefd2941719badaf9b3f192845",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/atoms-partners--docs`,
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
            required: true,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Companies",
            name: "companies",
            type: "list",
            subFields: [
                {
                    friendlyName: "Name",
                    name: "name",
                    type: "text",
                    required: true,
                },
                {
                    friendlyName: "Description",
                    name: "description",
                    type: "longText",
                    required: true,
                },
                {
                    friendlyName: "Link To Company",
                    name: "link",
                    type: "string",
                },
                // ImageInputsTemplate <-- see this template
                {
                    friendlyName: "Logo",
                    name: "image",
                    type: "object",
                    helperText: "Any Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/400",
                            required: true,
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
            ],
        },
    ],
};
